export default "__VITE_ASSET__B$A7kHZm__"